'use strict';
import util from "../util";
import validator from "../validator";
import toasts from '../toast-notify';
import analytics from "../analytics";

const email_regx = validator.regex.email;
const numericRegEx = /^(([1-9]*)|(([1-9]*)\.([0-9]*)))$/;
const specialCharacterRegEx = /[!@#$%^&*()_+\=\[\]{};:"\\|,.<>\/?]+/;
const $wrapper = $('#wrapper');
/**
 * Redesign Login Form
 * Validation Error Form 
 * Validation Passwords Form
 * Login Show
 * Login Hide
 * Logout / Social Login Toast Message
 * Forgot Password Email/ Sent
 * Checkout Login
 * */

/**
   * @function 
   * @description method to show the login modal dialog
   */
function loginShow(isIconClick = false) {
  const $html = $('html');
  const isNewNav = $html.find('.nav-redesign').length > 0;
  $html.addClass('modal-open').removeClass('nav-open filter-open');
  $('#login-wrapper-new').addClass('active');
  if (isIconClick) {
    analytics.trackAccountIconClick(isNewNav);
  } else{
    analytics.trackSignInDrawerOpen();
  }
}

/**
   * @function 
   * @description method to hide the login modal
   */
function loginHide() {
  // Login & overlay - New Login slide out 
  $('html').removeClass('modal-open');
  $('#login-wrapper-new').removeClass('active');
  if($('.nav-redesign').length  && $(window).width() < 991) {
    $('.icon-hamburger').show();
  }
}

/**
   * @function 
   * @description Back to Login when user close on second step or forgot link
   */
function loginRedesignStepOne() {
  // Check if any of the elements related to registration or password reset are present
  // If so, clear the form to reset the UI state
  if ($('.login-auth-registeruser, .account-registration-process, .reset-password-wrapper, .reset-password-success').length) {
    clearForm();
  }
}

/**
   * @function 
   * @description Email verification for the current user & new user credentials
   */
function userEmailAuth() {
  const $searchInput = $('.login-redesign-username .user-email input[type="email"]');

  const makeAjaxRequest = util.debounce(() => {
    const $form = $('#dwfrm_login');
    const data = $form.serialize() + '&email=' + $searchInput.val();

    $.ajax({
      url: Urls.loginOrRegister,
      data: data,
      type: "POST"
    }).done(function (response) {
      function toggleClassForElements(elements, className, action) {
        elements.forEach(element => {
          if (action === 'add') {
            $(element).addClass(className);
          } else {
            $(element).removeClass(className);
          }
        });
      }

      const selectors = {
        materialInput: '.material-input',
        loginWrapperNew: '.login-wrapper-new',
        loginAuth: 'loginAuth',
        registerAuth: 'registerAuth',
        visuallyHidden: 'visually-hidden',
        userEmailInput: '.login-redesign-username .user-email input',
        passwordInputText: '.login-redesign-password .input-text',
        registrationInputText: '.registration .input-text',
        loginRedesignUsernameInputText: '.login-redesign-username .input-text',
        loginAuthEmailInput: '.login-auth-email input',
        loginAuthEmailErrorPlacement: '.login-auth-email .error-placement',
        registrationMaterialInput: '.registration .material-input',
        registrationInput: '.registration input',
      };

      $searchInput.closest(selectors.materialInput).find('.error-placement').remove();

      if (response.existingUser) {
        toggleClassForElements([selectors.loginWrapperNew], selectors.loginAuth, 'add');
        toggleClassForElements([selectors.loginWrapperNew], selectors.registerAuth, 'remove');
        toggleClassForElements([".account-search-msg-header", ".account-registration-msg-header", ".login-redesign-registration-form", ".account-registration-process", ".login-auth-registeruser .error-form", ".reset-account-part"], selectors.visuallyHidden, "add");
        $(selectors.userEmailInput).addClass('valid');
        toggleClassForElements([".account-login-msg-header", ".reset-password-link", ".login-auth-registeruser", ".login-redesign-password"], selectors.visuallyHidden, "remove");
        $(".login-redesign-password").removeClass("registration");
        $(".login-drawer-banner").removeClass(selectors.visuallyHidden);

        $(selectors.passwordInputText).val() !== '' && $('.login-redesign-password .material-input').addClass('focus-in');
        $(selectors.loginRedesignUsernameInputText).val() !== '' && $('.login-redesign-username .material-input').addClass('focus-in valid');
        validator.initForm('.login-auth-email');
        validateFormLogin();
      } else {
        toggleClassForElements([selectors.loginWrapperNew], selectors.registerAuth, 'add');
        toggleClassForElements([selectors.loginWrapperNew], selectors.loginAuth, 'remove');
        $(".login-redesign-password").addClass("registration").removeClass(selectors.visuallyHidden);
        $(".login-drawer-banner").addClass(selectors.visuallyHidden);
        $(".login-redesign-username .user-email").addClass("focus-in valid");
        $(selectors.userEmailInput).addClass('valid');
        toggleClassForElements([".account-registration-msg-header", ".login-redesign-registration-form", ".account-registration-process", "#login-wrapper-new .divider", "#login-wrapper-new .social-login-holder"], selectors.visuallyHidden, "remove");
        toggleClassForElements([".account-login-msg-header", ".reset-password-link", ".login-auth-registeruser", ".account-search-msg-header", ".registration .error-form"], selectors.visuallyHidden, "add");

        $(selectors.registrationInputText).val() !== '' && $(selectors.registrationMaterialInput).addClass('focus-in');
        $(selectors.loginRedesignUsernameInputText).val() !== '' && $('.login-redesign-username .material-input').addClass('focus-in valid');

        $(selectors.loginAuthEmailInput).removeClass('error');
        $(selectors.loginAuthEmailErrorPlacement).remove();
        validateInputs();
        validateFormLogin();
        registerPasswordValidator();
        $(selectors.registrationInput).val() === '' && $(selectors.registrationMaterialInput).removeClass('focus-in');
        if ($(selectors.registrationMaterialInput + ' .input-text').is(':-webkit-autofill')) {
          $(selectors.registrationMaterialInput + ' .input-text').trigger('focus');
        }
      }
    });
  }, 500);

  $searchInput.on('focus keyup', function (e) {
    if (email_regx.test($searchInput.val())) {
      makeAjaxRequest();
    }
  });
}

/**
   * @function 
   * @description Email & password validation for login
   */
function loginSuccessRedesign() {
  $('#login-user').on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    const form = $('#dwfrm_login');
    const data = form.serialize() + '&format=ajax';
    $('.error-form.invalid').remove();
    const $loginWrapper = $('#login-wrapper-new'); // Create a variable for reuse

    $.ajax({
      url: Urls.loginForm,
      data: data,
      type: "POST"
    }).done(function (response) {
      if (response && response.errorCode && response.errorCode === 'ERROR_PASSWORD_EXPIRED') {
        $('.login-redesign-password-expiry').removeClass('visually-hidden');
      } else if (response && response.errorCode && response.errorCode === 'accountLocked') {
        $('.login-redesign-login-locked').removeClass('visually-hidden');
      } else if (response && response.errorCode && response.errorCode === 'remainingLoginAttempts') {
        $('.login-redesign-login-willbelocked').removeClass('visually-hidden');
      } else if (response && response.invalidCredentials) {
        $('.login-redesign-login-error').removeClass('visually-hidden');
      }
      
      async function handleLogin() {
        await new Promise(resolve => setTimeout(resolve, 1000));
        validateFormLogin();
      }
      handleLogin();
      
      if (response && response.invalidCredentials) {
        $loginWrapper.find('input.error').length && $loginWrapper.find('input').removeClass('error');
        $loginWrapper.find(".user-email").addClass("focus-in");
        $loginWrapper.find('.login-auth-registeruser .user-email').addClass('valid');
      } else {
        if (form.hasClass('wishlist-login')) {
          const wishlistpid = form.data('pid');
          if(wishlistpid) {
            $(`.wishlist-icon[data-element-pid="${wishlistpid}"]`).trigger('click');
          }
        }
        $loginWrapper.find('.login-form-content-new').html(response);
        $(".login-drawer-banner").addClass('visually-hidden');
        $loginWrapper.find('.divider').remove();
        $loginWrapper.find('.social-login-wrapper').remove();
        $loginWrapper.find('.login-content-new').addClass('animate__fadeInDown');

        setTimeout(() => {
          $loginWrapper.find('.login-close').trigger('click');
          if (window.location.href.indexOf("Login-Show") >= 0) {
            document.location.href = Urls.myAccount;
          } else {
            location.reload();
          }
        }, 1000);
      }
    });
  });
}

/**
   * @function 
   * @description Account created successfully
   */
function accountCreatedSuccess() {
  $('#register-user').on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $form = $('#dwfrm_login');
    const data = $form.serialize() + '&format=ajax';

    if(validateRegisterForm()) {
      $.ajax({
        url: Urls.registrationFormSubmitRedesign,
        data: data,
        type: "POST"
      }).done(function (response) {
        $('.registerAuth .login-form-content-new').html(response);
        const $loginWrapperNew = $('#login-wrapper-new');
        if ($loginWrapperNew.find('.registration-success-wrapper').length) {
          if ($form.hasClass('wishlist-login')) {
            const wishlistpid = $form.data('pid');
            if(wishlistpid) {
              $(`.wishlist-icon[data-element-pid="${wishlistpid}"]`).trigger('click');
            }
          }
          $loginWrapperNew.find('.divider').remove();
          $loginWrapperNew.find('.social-login-wrapper').remove();
          $loginWrapperNew.find('.login-content-new').addClass('animate__fadeInDown');

          sessionStorage.setItem('AccountRegistered', 'true');
          localStorage['AccountRegistered'] = true;

          function handleLoginClose() {
            $loginWrapperNew.find('.login-close').trigger('click');
            location.reload();
          }

          setTimeout(handleLoginClose, 3000);
        }
      });
    }
  });
}

/**
   * @function 
   * @description Password validation
   */
function validateFormLogin() {
  const emailInput = $('.login-redesign-username .user-email input[type="email"]');
  const passwordInput = $('.login-redesign-password .user-pass input[type="password"]');
  const submitBtn = $('#login-user');
  const firstName = $('.first-name');
  const lastName = $('.last-name');
  const agreeCheckbox = $('.user-consent-registration .termsandconditions');

  // Email Validation - Input
   function handleEmailChange(e) {
    const $password = $('.login-redesign-password');
    if (email_regx.test(emailInput.val())) {
      $password.find('.user-email input').addClass('valid');
    } else {
      $password.find('.user-email input').removeClass('valid');
    }
  }

  // Password Validation - Input
  function handleInputChange() {
    if (passwordInput.val() !== '' && passwordInput.val().length >= 8 && emailInput.val() !== '') {
      submitBtn.prop("disabled", false);
      submitBtn.removeClass('disabled');
      $(firstName).find('input').removeClass('error');
      $(firstName).find('.error-placement').remove();
      $(lastName).find('input').removeClass('error');
      $(lastName).find('.error-placement').remove();
      $(agreeCheckbox).removeClass('error');
      $(agreeCheckbox).closest('.material-input').find('.error-placement').remove();
    } else {
      submitBtn.prop("disabled", true);
      submitBtn.addClass('disabled');
    }
  }

  if ($(emailInput).val() !== '') {
    $(emailInput).closest('.material-input').addClass('focus-in');
  }

  if ($(passwordInput).val() !== '') {
    $(passwordInput).closest('.material-input').addClass('focus-in');
  }

  if ($(passwordInput).val() == '') {
    $(submitBtn).addClass('disabled');
    $('.login-redesign-password .user-pass .input-text').closest('.material-input').removeClass('focus-in');
  }

  emailInput.on('focus keyup blur', handleEmailChange);
  !$('.registerAuth').length > 0 && passwordInput.on('focus keyup blur', handleInputChange);
}

/**
   * @function 
   * @description Registration Password validation function
   */
function registerPasswordValidator() {
  const passwordInput = $('.login-redesign-password input');
  const emailInput = $('.login-redesign-username input');
  const $submitBtn = $('#register-user');
  const firstName = $('.first-name input');
  const lastName = $('.last-name input');
  const agreeCheckbox = $('.user-consent-registration .termsandconditions');
  const newsletterCB = $('.user-consent-newsletter .addtoemaillist');
  const $password_length = $('#password_length');
  const $password_number = $('#password_number');
  const $password_special = $('#password_special');
  const $password_rules = $('#password_rules');

  function handleInputChange() {
    if (firstName.val() !== '' &&
      lastName.val() !== '' &&
      emailInput.val() !== '' &&
      passwordInput.val() !== '' &&
      $password_length.hasClass('valid') &&
      $password_number.hasClass('valid') &&
      $password_special.hasClass('valid')) {
        $submitBtn.prop("disabled", false);
        $submitBtn.removeClass('disabled');
    } else {
      $submitBtn.prop("disabled", true);
      $submitBtn.addClass('disabled');
    }
  }

  function handlePasswordRules() {
    if (!$password_length.hasClass('valid') || !$password_number.hasClass('valid') || !$password_special.hasClass('valid')) {
      $password_rules.show();
    } else {
      $password_rules.hide();
    }
  }

  newsletterCB.on('change', function (e) {
    const isChecked = $(this).is(':checked');
    $('.user-consent-it .consentpref').prop('disabled', !isChecked);
	});

  agreeCheckbox.on('change', handleInputChange);
  passwordInput.on('focus keyup change', validateInputs);
  passwordInput.on('focus keyup change ', handlePasswordRules);
  passwordInput.on('focus keyup blur', handleInputChange);
  firstName.on('focus keyup blur', handleInputChange);
  lastName.on('focus keyup blur', handleInputChange);
  emailInput.on('focus keyup blur', handleInputChange);
}

function validateInputs() {
  let password = $('.login-redesign-password input').val();
  let all_pass = true;

  const number = password.match(/[0-9]/); // Number
  const alpha = password.match(/[a-zA-Z]/); // Alphabet
  const speCharacter = password.match(/^(?=.*[_\W]).+$/); // Special character 
  const $password_length = $('#password_length');
  const $password_number = $('#password_number');
  const $password_special = $('#password_special');

  if (password.length < 8) {
    $password_length.removeClass('valid');
    $password_length.find('.icon').removeClass('checkmark-valid').addClass('icon-close');
      all_pass = false;
  } else {
    $password_length.addClass('valid');
    $password_length.find('.icon').removeClass('icon-close').addClass('checkmark-valid');
  }

  if (number) {
    $password_number.addClass('valid');
    $password_number.find('.icon').removeClass('icon-close').addClass('checkmark-valid');
  } else {
    $password_number.removeClass('valid');
    $password_number.find('.icon').removeClass('checkmark-valid').addClass('icon-close');
      all_pass = false;
  }

  if (speCharacter) {
    $password_special.addClass('valid');
    $password_special.find('.icon').removeClass('icon-close').addClass('checkmark-valid');
  } else {
    $password_special.removeClass('valid');
    $password_special.find('.icon').removeClass('checkmark-valid').addClass('icon-close');
      all_pass = false;
  }
}

function firstNameValidation() {
  let validateName = validator.regex.name;
  return [
    validateName.test($('.first-name input').val()),
    !numericRegEx.test($('.first-name input').val()),
    !specialCharacterRegEx.test($('.first-name input').val()),
  ].every(Boolean);
}

function lastNameValidation() {
  let validateName = validator.regex.name;
  return [
    validateName.test($('.last-name input').val()),
    !numericRegEx.test($('.last-name input').val()),
    !specialCharacterRegEx.test($('.last-name input').val()),
  ].every(Boolean);
}

function validateRegisterForm() {
  const [
    email,
    emailValid,
    firstName,
    lastName,
    password,
    agreeTerms,
    lengthValid,
    numberValid,
    specialValid,
  ] = [
      $('.login-redesign-username input').val(),
      email_regx.test($('.login-redesign-username input').val()),
      firstNameValidation(),
      lastNameValidation(),
      $('.login-redesign-password input').val(),
      $('.user-consent-registration .termsandconditions').is(':checked'),
      $('#password_length').hasClass('valid'),
      $('#password_number').hasClass('valid'),
      $('#password_special').hasClass('valid'),
    ];

  return [email, emailValid, firstName, lastName, password, agreeTerms, lengthValid, numberValid, specialValid].every(Boolean);
}

/**
   * @function 
   * @description Password Show Hide Toggle functionality
   */
function passwordShowHideToggle() {
  const $passwordInput = $('.login-redesign-password .user-pass input[type="password"]');
  $('.login-redesign-password .user-pass').on('click', '.icon', function () {
    if ($(this).hasClass('icon-eye')) {
      $(this).removeClass('icon-eye').addClass('icon-eye-slash');
      $passwordInput.attr("type", "text");
    } else {
      $(this).removeClass('icon-eye-slash').addClass('icon-eye');
      $passwordInput.attr("type", "password");
    }
  });
}

/**
   * @function 
   * @description Clear / Empty form data
   */
function clearForm() {
  setTimeout(() => {
    const $formData = $('.login-auth-email');
    $formData.find('input:not(.data-field)').val('').removeClass('error');
    $formData.find('.error-placement').remove();
    $formData.find('.icon_checkmark').remove();
    $formData.find('.material-input').removeClass('focus-in');
    $('.login-form-content-new, .account-search-msg-header, .divider, .social-login-holder').removeClass('visually-hidden');
    $(".login-redesign-password, .account-login-msg-header, .account-registration-msg-header, .reset-password-link, .login-auth-registeruser, .account-registration-process, .login-redesign-registration-form, .login-redesign-password .error-form").addClass("visually-hidden");
    $('.login-redesign-password .user-pass .icon.icon-eye-slash').length > 0 && $('.login-redesign-password .user-pass .icon').trigger('click');
    $formData.find('input[type=checkbox]').is(':checked') && $formData.find('input[type=checkbox]').trigger('click');
    $formData.find('input.consentpref').is(':checked') && formData.find('input.consentpref').prop("disabled", false).trigger('click');
    $('.reset-password-wrapper').addClass('visually-hidden').removeClass('animate__fadeInDown');
    $('.reset-password-success').addClass('visually-hidden').removeClass('animate__fadeIn');
  }, 300);
}

/**
   * @function 
   * @description Forgot Password Link send email button click - step for forgot password
   */
function resetPasswordSendLink() {
  $wrapper.on('click', '#login-wrapper-new .password-reset-link', function (e) {
    e.preventDefault();
    const userEmail = $('.login-redesign-username .user-email input[type="email"]').val();
    const $resetPasswordWrapper = $('.reset-password-wrapper');
    const $loginWrapperNew = $('#login-wrapper-new');
    $resetPasswordWrapper.find('.user-email').html(userEmail);
    $('.login-form-content-new').addClass('visually-hidden')
    $loginWrapperNew.find('.divider').addClass('visually-hidden');
    $loginWrapperNew.find('.social-login-holder').addClass('visually-hidden');
    $resetPasswordWrapper.removeClass('visually-hidden').addClass('animate__fadeInDown');
    $('.reset-link-btn').data('email', userEmail);
  });
}

/**
   * @function 
   * @description Forgot Password email send to the user email - Last Step for forgot password
   */
function resetPasswordSendEmail() {
  $wrapper.on('click', '#login-wrapper-new .reset-link-btn', function (e) {
    e.preventDefault();
    const email = $(this).data('email');
    $('.reset-password-wrapper').addClass('visually-hidden');
    $('.reset-password-success').removeClass('visually-hidden').addClass('animate__fadeIn');
    $.ajax({
      url: Urls.resetPasswordSendEmail + '?email=' + email,
      type: "POST"
    }).done(function (response) {
      function handleTimeout() {
        loginHide();
        loginRedesignStepOne();
      }

      setTimeout(handleTimeout, 5000);
    });
  });
}

function newpasswordconfirm() {
  $wrapper.on('click', '#NewPasswordForm button', function (e) {
    e.preventDefault();
    const $password = $('#NewPasswordForm .userpass input[type="password"]');
    const $passwordconfirm = $('#NewPasswordForm .userpass .passwordconfirm');
    const $form = $('#NewPasswordForm');
    const data = $form.serialize() + '&password=' + $password.val() + '&confirmpassword=' + $passwordconfirm.val();
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
    $.ajax({
      url: Urls.setNewPasswordFormRedesign + '?Token=' + urlParams.get('Token'),
      data: data,
      type: "POST"
    }).done(function (response) {
      if (response && response.ErrorCode) {
        const errorKey = `ACCOUNT_PASSWORDRESET_${response.ErrorCode}`;
        const errorMessage = Resources[errorKey];

        // Display the error message
        const errorContainer = document.getElementById('error-message-container');
        if (errorContainer) {
          errorContainer.textContent = errorMessage;
          errorContainer.classList.remove('visually-hidden');
        }
    } else if (response && response.isPasswordChanged) {
        $('.reset-account-part').addClass('visually-hidden');
        $('.setnewpasswordconfirm').removeClass('visually-hidden');
        setTimeout(() => {
          if (response && response.ContinueURL) {
            // Redirect to the URL
            window.location.href = response.ContinueURL;
          }
        }, 500);
      }
    });
    
  }
  });
}

/**
   * @function 
   * @description User logged out successfully, able to see toast dialog
   */
function loggedOut() {
  if (localStorage.userAuth == "loggedOut") {
    toasts.init(NOTIFICATION_SUCCESS_TEXT_LOGOUT, 'active animate__fadeInDownToast', 'icon-sign-out');
    localStorage.removeItem('userAuth');
  } else {
    if ($('.logged-out-success').length) {
      $('.logged-out-success').remove();
    }
    $(".account-left-nav li[data-attr='account-log-out'], .log-out-link").on('click', handleLogoutClick);
  }
}

function handleLogoutClick() {
  localStorage.setItem("userAuth", "loggedOut");
  localStorage.removeItem('uservalidation');
  sessionStorage.removeItem('uservalidation');
}

/**
   * @function 
   * @description Checkout login modal dialog
   */
function checkoutLogin() {

  var checkoutEmail = $('.checkout-login-container input[type="email"]');
  checkoutEmail.on('focus keyup keydown', function (e) {
    const email_regx = validator.regex.email;
    if (email_regx.test(checkoutEmail.val())) {
      setTimeout(() => {
        $.ajax({
          url: Urls.loginOrRegister + '?email=' + checkoutEmail.val(),
          type: "POST"
        }).done(function (response) {
          const $userAuthExisting = $('.user-auth-existing');
          if (response.existingUser) {
            $userAuthExisting.removeClass('hidden');
            $('.user-auth-guest').addClass('hidden');
          } else {
            $userAuthExisting.addClass('hidden');
            $('.user-auth-guest').removeClass('hidden');
          }
        });
      }, 200);
      setTimeout(() => {
        if ($('#secondary .right-side-checkout').length && $(window).width() >= 640 && $('.checkout_page').length) {
          var stickySidebar = new StickySidebar('#secondary .right-side-checkout', {
            topSpacing:  115,
            bottomSpacing: 10,
            resizeSensor: true,
            innerWrapperSelector: '.sidebar__inner'
          });
        }
      }, 5000);
    } else {
      return;
    }
  });
  
  $wrapper.on("click", ".checkout-login-container .checkout-login-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var emailInput = $('.login-redesign-username .user-email input[type="email"]');
    var passInput = $('.login-redesign-password .input-text');
    $(emailInput).val($(checkoutEmail).val());
    $(emailInput).trigger('focus');
    $("<i class='icon_checkmark'></i>").insertBefore($(emailInput));
    $(passInput).val() == '' && $(passInput).removeClass('error');
    analytics.trackClickCtaAccountModal();
    loginShow();
  });
}

var redesignLogin = {
  /**
   * @function
   * @description method to init redesignLogin
   */
  init: function () {

    // Login show
    $wrapper.on('click', '#signin-link > a', function (e) {
      if (!window.User.isCustomerAuthenticated) {
        e.preventDefault();
        e.stopPropagation();
        if (window.location.search) {
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('forgotpassword') === 'true') {
            // Call the loginShow() function
            loginShow(true);
            $('#login-wrapper-new').addClass('forgot-password');
            $('.reset-account-part').removeClass('visually-hidden');
          } else {
            loginShow(true);
          }
        } else {
          loginShow(true);
        }
      }
    });
    
    $wrapper.on('click', '.guest-header-message button, .pdp-login-banner .guest-header-message', function (e) {
      if (!window.User.isCustomerAuthenticated) {
        if (pageInfo.pageCategory === 'Home Page') {
            var loginLocation = null;
            if ($(this).closest('.homepage-first-login-banner').length) {
                loginLocation = 'top_location';
            } else if ($(this).closest('.homepage-second-login-banner').length) {
                loginLocation = 'bottom_location';
            }
            analytics.trackClickCtaAccountModal(loginLocation);   
        } else {
            analytics.trackClickCtaAccountModal();
        }
        loginShow();
      }
    });

    //perks CTA click (the anchor/arrow)
    $wrapper.on('click', 'a.guest-header-message', function (e) {
        analytics.trackClickCtaPerksAccountModal();
    });

    // Login & overlay - Login hide 
    $('#login-wrapper-new .login-close, #login-wrapper-new .login-overlay').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      loginHide();
      loginRedesignStepOne();
    });

    userEmailAuth();
    loggedOut();
    loginSuccessRedesign();
    resetPasswordSendLink();
    resetPasswordSendEmail();
    newpasswordconfirm();
    accountCreatedSuccess();
    passwordShowHideToggle();
    // Social login toast alert dialog
    if ($('.social-login-success').length) {
      const toast = $('.toast-container');
      toast.addClass('active animate__fadeInDownToast');
      window.setTimeout(() => {
          toast.removeClass('animate__fadeInDownToast').addClass('animate__fadeInUpToast');
          toast.remove();
      }, 3000);

      if (window.User.isSocialNewlyRegistered) {
          localStorage.setItem('AccountRegistered', true);
      }
    }

    // Login show on checkout only
    if ($('.pt_checkout').length) {
      checkoutLogin();
    }

    if (window.User.isCustomerAuthenticated) {
      $('#login-wrapper-new').remove();
    }
  },
  
  loginShow: loginShow,
  loginHide: loginHide
};

export default redesignLogin;
